import {AbstractViewModel} from '../../../core/interfaces/abstract-view-model';
import {ProjectCollaborationAssetApiModel} from '../../../api/models/collaboration/project-collaboration-asset.api-model';
import {MediaObjectViewModel} from '../../../core/models/media-object.view-model';
import {MediaObjectApiModel} from '../../../api/models/media-object.api-model';
import {UserViewModel} from '../settings/user.view-model';
import {UserApiModel} from '../../../api/models/user.api-model';

export class ProjectCollaborationAssetViewModel extends AbstractViewModel<ProjectCollaborationAssetApiModel> {
  public constructor(protected apiModel: ProjectCollaborationAssetApiModel = new ProjectCollaborationAssetApiModel()) {
    super(apiModel);
    this.fromApiModel(apiModel);
  }

  public collaboration: string | {'@id'?: string; id?: number};
  public mediaPost: string | {'@id'?: string; id?: number};
  public media: MediaObjectViewModel;
  public createdBy: UserViewModel;
  public approvedBy: UserViewModel | null;
  public rejectedBy: UserViewModel | null;
  public status: string;
  public caption: string;
  public reviewNote: string;
  public ownerDecisionAt: Date;
  public approvedAt: Date;
  public rejectedAt: Date;
  public isVisibleInBaseProject: boolean;
  public syncedToBaseProjectAt: Date;
  public orderPosition: number;
  public mediaPostOrderPosition: number;
  public createdAt: Date;
  public updatedAt: Date;

  fromApiModel(apiModel: ProjectCollaborationAssetApiModel): this {
    this.id = apiModel.id;
    this.collaboration = apiModel.collaboration;
    this.mediaPost = apiModel.mediaPost;
    this.status = apiModel.status;
    this.caption = apiModel.caption;
    this.reviewNote = apiModel.reviewNote;
    this.ownerDecisionAt = apiModel.ownerDecisionAt;
    this.approvedAt = apiModel.approvedAt;
    this.rejectedAt = apiModel.rejectedAt;
    this.isVisibleInBaseProject = apiModel.isVisibleInBaseProject;
    this.syncedToBaseProjectAt = apiModel.syncedToBaseProjectAt;
    this.orderPosition = apiModel.orderPosition;
    this.mediaPostOrderPosition = apiModel.mediaPostOrderPosition || 0;
    this.createdAt = apiModel.createdAt;
    this.updatedAt = apiModel.updatedAt;

    this.media = typeof apiModel.media === 'string'
      ? (() => {
          const vm = new MediaObjectViewModel();
          vm['@id'] = apiModel.media as string;
          vm.id = Number((apiModel.media as string).split('/').pop()) || 0;
          return vm;
        })()
      : new MediaObjectViewModel(apiModel.media as MediaObjectApiModel);

    this.createdBy = typeof apiModel.createdBy === 'string'
      ? (() => {
          const vm = new UserViewModel();
          vm['@id'] = apiModel.createdBy as string;
          vm.slug = (apiModel.createdBy as string).split('/').pop() || null;
          return vm;
        })()
      : new UserViewModel(apiModel.createdBy as UserApiModel);

    this.approvedBy = !apiModel.approvedBy
      ? null
      : (typeof apiModel.approvedBy === 'string'
        ? (() => {
            const vm = new UserViewModel();
            vm['@id'] = apiModel.approvedBy as string;
            vm.slug = (apiModel.approvedBy as string).split('/').pop() || null;
            return vm;
          })()
        : new UserViewModel(apiModel.approvedBy as UserApiModel));

    this.rejectedBy = !apiModel.rejectedBy
      ? null
      : (typeof apiModel.rejectedBy === 'string'
        ? (() => {
            const vm = new UserViewModel();
            vm['@id'] = apiModel.rejectedBy as string;
            vm.slug = (apiModel.rejectedBy as string).split('/').pop() || null;
            return vm;
          })()
        : new UserViewModel(apiModel.rejectedBy as UserApiModel));

    return this;
  }

  getApiModel(): ProjectCollaborationAssetApiModel {
    return this.apiModel;
  }

  toApiModel(): ProjectCollaborationAssetApiModel {
    this.apiModel.collaboration = this.collaboration;
    this.apiModel.media = this.media?.['@id'];
    this.apiModel.caption = this.caption;
    this.apiModel.mediaPost = this.mediaPost;

    return this.apiModel;
  }
}
